/* import __COLOCATED_TEMPLATE__ from './reviewable-field-tags.hbs'; */
import Component from "@ember/component";

export default Component.extend({
  actions: {
    onChange(tags) {
      this.set("value", tags);

      this.valueChanged &&
        this.valueChanged({
          target: {
            value: tags,
          },
        });
    },
  },
});
